// extracted by mini-css-extract-plugin
export var page404Title = "Button-module--page404-title--1pAcE";
export var button = "Button-module--button--2t432";
export var white = "Button-module--white--2Xn31";
export var black = "Button-module--black--25G20";
export var blackOnLight = "Button-module--blackOnLight--DZE-N";
export var clearOnLight = "Button-module--clearOnLight--2Ke66";
export var blackOnBlack = "Button-module--blackOnBlack--1BTtq";
export var whiteOnBlack = "Button-module--whiteOnBlack--2SD_z";
export var clear = "Button-module--clear--ylMvk";
export var icon = "Button-module--icon--ahMay";
export var playIconClear = "Button-module--playIconClear--3S8UL";
export var phoneIcon = "Button-module--phoneIcon--i0mmH";
export var phoneIconWhite = "Button-module--phoneIconWhite--3oJhd";